<template>
  <v-hover v-slot:default="{ hover }">
    <div class="pa-1">
      <v-row no-gutters align="start">
        <v-col cols="1">
          <v-icon large color="grey">mdi-account-circle</v-icon>
        </v-col>
        <v-col cols="11">
          <v-row no-gutters>
            <span class="text-body-2 font-weight-medium mr-1">{{ comment.autor }}</span>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon small icon color="primary" v-on="on" @click="edit" v-if="comment.canEdit">mdi-pencil</v-icon>
              </template>
              <span>{{ $t('Edit') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon small class="ml-1" icon color="red" v-on="on" @click="remove" v-if="canDelete">mdi-delete</v-icon>
              </template>
              <span>{{ $t('Delete') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-badge overlap bordered>
                  <template v-slot:badge>
                    <span v-on="on">{{ comment.pageNumber }}</span>
                  </template>
                  <v-icon small class="ml-1" v-on="on">mdi-bookmark</v-icon>
                </v-badge>
              </template>
              <span>{{ $t('Page') }}</span>
            </v-tooltip>

            <span class="text-caption grey--text ml-2">{{ comment.date }}</span>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <div class="text-body-2" style="line-height: normal;" v-html="comment.text" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </div>
  </v-hover>
</template>

<script>
import Utils from '@/ecm/common/Utils';
export default {
    props: {
        comment: {
            type: Object
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        edit() {
            this.$emit('on-edit-comment', Utils.object.toJS(this.comment));
        },
        remove() {
            this.$emit('on-remove-comment', this.comment.id);
        }
    }
};
</script>